<template>
  <div>
    <b-form class="mb-4" @submit.prevent="fetchContacts">
      <b-input-group>
        <b-form-input type="search" :placeholder="$t('search')" v-model="searchText" minlength="2" maxlength="150"/>
        <b-input-group-append>
          <b-button type="submit" variant="outline-primary">
            <b-icon icon="search" />
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </b-form>

    <div class="py-3 text-center" v-if="isLoading">
      <b-spinner />
    </div>

    <b-list-group v-else>
      <div v-if="!contacts.length" class="py-3 text-center text-secondary">
        {{ $t("noData") }}
      </div>
      <b-list-group-item v-for="contact in contacts" :key="contact.id" button @click="picked(contact)">
        <div>{{ contact.name }}</div>
        <div><small class="text-secondary">{{ contact.subtitleText }}</small></div>
        <b-row class="small">
          <b-col cols="7">
            <b-icon class="mr-1" icon="envelope"/>{{ contact.email }}
          </b-col>
          <b-col cols="5" v-if="contact.phone">
            <b-icon class="mr-1" icon="telephone"/> {{ contact.phone }}
          </b-col>
        </b-row>
      </b-list-group-item>
    </b-list-group>

  </div>
</template>

<style lang="scss" scoped>

</style>

<script lang="ts">
import {Component, Emit, Prop, Vue} from 'vue-property-decorator';
  import _ from "lodash";
  import BaseComponent from "@/components/BaseComponent";

  import * as contactService from "@/service/contactService";


  @Component
  export default class PickContactModal extends BaseComponent {

    @Prop({ required: true }) modalId: string;

    isLoading = false;

    searchText = "";
    contacts = [];


    mounted() {
      this.fetchContacts();
    }

    async fetchContacts() {
      try {
        this.isLoading = true;
        this.contacts = (await contactService.getAllContacts(1, 10, this.searchText?.trim())).data;

        for (const c of this.contacts) {
          c.subtitleText = [c.title, c.department, c.organization].map(it => it?.trim()).filter(_.identity).join(" - ");
        }

      } catch (e) {
        this.toastError(e);
      } finally {
        this.isLoading = false;
      }
    }

    @Emit()
    picked(contact) {
      this.$bvModal.hide(this.modalId);
    }

  }
</script>
